<template>
  <div class="iCcard">
    <div class="content">
      <div class="iCcard-top">
        <div class="ic-left">
          <span style="margin-right:40px">看板管理</span>
        </div>
        <div class="btns">
          <el-button type="primary" @click="add_ed(0)" class="last-el-button">新增</el-button>
        </div>
      </div>
      <div class="search-input-btn">
        <div class="input-small">
          <span>名称：</span>
          <el-input v-model="biName" clearable placeholder="请输入看板名称" class="el-input-mysmall"></el-input>
        </div>
        <div class="input-small" style="margin-left:20px">
          <span>类型：</span>
          <el-select v-model="biType" placeholder="请选择" clearable>
            <el-option v-for="item in biTypeList" :key="item.id" :label="item.label" :value="item.lable"> </el-option>
          </el-select>
        </div>
        <el-button type="primary" plain class="search-btn" @click="getList">查询</el-button>
      </div>

      <div class="iCcard-table">
        <!--  -->
        <el-table :data="tableData" v-loading="tabloading" border stripe style="width: 100%" :height="heights">
          <template slot="empty">
            <span class="noData">
              <img src="@/assets/noData.png" alt="暂无数据">
              <span class="text">暂无数据</span>
            </span>
          </template>
          <el-table-column label="序号" width="90" align="center">
            <template slot-scope="scope">
              <span>{{ scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="biName" label="名称" width="400"> </el-table-column>
          <el-table-column label="类型" width="300">
            <template #default="{row}">
              <span>{{row.biType == 'UNIVERSAL'?'通用':'指定'}}</span>
              <span v-if="row.biType == 'CUSTOMIZED'" style="margin-left:10px">=> {{row.unitName}}</span>
            </template>
          </el-table-column>
          <el-table-column label="状态" width="120" align="center">
            <template #default="{row}">
              <span>
                <el-switch v-model="row.status" active-color="#409eff" inactive-color="#dcdfe6"
                  @change="switch_fn(row.status,row)"></el-switch>
              </span>
            </template>
          </el-table-column>

          <el-table-column prop="memo" label="备注" width="400"> </el-table-column>
          <el-table-column label="操作" align="center" min-width="200" fixed='right'>
            <template #default="{row}">
              <span class="buttoned_box">
                <div class="mr-20" @click="binding_fn(row)" v-if="row.userId">
                  <el-tooltip class="item" effect="dark" content="绑定" placement="top">
                    <elIconBtn btnType='binding'></elIconBtn>
                  </el-tooltip>
                </div>
                <div class="mr-20" @click="binding_fn(row)" v-else>
                  <el-tooltip class="item" effect="dark" content="换绑" placement="top">
                    <elIconBtn btnType='binding'></elIconBtn>
                  </el-tooltip>
                </div>
                <div class="mr-20" @click="edit_fn(row)">
                  <el-tooltip class="item" effect="dark" content="编辑" placement="top">
                    <elIconBtn btnType='edit'></elIconBtn>
                  </el-tooltip>
                </div>
                <div @click="del_fn(row)">
                  <el-tooltip class="item" effect="dark" content="删除" placement="top">
                    <elIconBtn btnType='del'></elIconBtn>
                  </el-tooltip>
                </div>
              </span>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="el-loading-mask" v-show="loading" style="z-index: 9999;">
        <div class="el-loading-spinner">
          <svg viewBox="25 25 50 50" class="circular">
            <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
          </svg>
          <p>正在打开编辑器....</p>
        </div>
      </div>

    </div>

    <!-- 新增修改 -->
    <el-dialog width="25%" v-dialogDrag title="新增看板" :close-on-click-modal='false' :visible.sync="dialogVisible">
      <div style="display: flex;">
        <el-form :model="temp" ref="temp" :rules="rules" style="width: 80%;height: 400px;padding-top: 10px;">
          <el-radio v-model="radio" label="通用">通用看板</el-radio>
          <p style="margin:15px 0px"></p>
          <el-radio v-model="radio" label="指定">指定看板</el-radio>
          <div class="unit-tree" style="width:300px;height:360px" v-show="radio == '指定'">
            <el-scrollbar style="height:100%;width: 100%;">
              <el-tree :data="dataList" :expand-on-click-node="false" node-key="id" :props="defaultProps"
                :highlight-current='true' ref="tree" @node-click="nodeClick">
                <span class="custom-tree-node" slot-scope="{node}">
                  <img src="../../../public/static/image/elTree/1.9.png" />
                  <span style="padding-left: 5px;">{{node.label}}</span>
                </span>
              </el-tree>
            </el-scrollbar>
          </div>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="add_fn('temp')">确定</el-button>
      </div>
    </el-dialog>

    <!-- 绑定用户 -->
    <el-dialog width="25%" v-dialogDrag title="绑定用户" :close-on-click-modal='false' :visible.sync="dialogUser">
      <div style="display: flex;">
        <el-form :model="tempUser" ref="temp" style="width: 80%;height: 400px;padding-top: 10px;">
          <el-scrollbar style="height:100%;width: 100%;">
            <div v-for="item in userList" :key="item.userId" style="margin-bottom:15px">
              <el-radio v-model="radioUser" :label="item.userId">{{item.username}}</el-radio>
            </div>
          </el-scrollbar>

        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogUser = false">取 消</el-button>
        <el-button type="primary" @click="addUser_fn">确定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
  // import {findICCards,saveIcCard,deleteIcCard,icCardSaveExcel} from "../../api/zhongshanMeter";
  import {getBIList,deleteBI,BiStatus,bindingUser} from "../../api/customKanBanApi";
  import {statementAppTypeGroup,statementVariableTree} from "../../api/newReport";
  import elIconBtn from '@/components/module/iconBtns.vue'
  import {findAppTypeTree} from "../../api/application";
  export default {
    components: {
      elIconBtn
    },
    data () {
      return {
        tabloading: true,
        biName: "",
        defaultProps: {
          children: 'next',
          label: 'name',
        },
        radio: "通用",
        heights: Math.round((document.getElementById('app').clientHeight)*0.74),//屏幕高度 - 导航栏高度
        //查询
        loading: false,
        total: 0,
        currentPage: 1,
        currentSize: 15,
        //弹窗
        dialogVisible: false,
        dialogStatus: '',

        //新增修改对象
        temp: {
          'cardNum': "",
          'remarks': "",
        },
        //星号必填
        rules: {
          cardNum: [
            {required: true,message: '请输入卡号',trigger: 'blur'}
          ]
        },
        //表格数据
        tableData: [],
        biType: "",
        //类型
        biTypeList: [
          {
            id: "UNIVERSAL",
            label: "通用"
          },
          {
            id: "CUSTOMIZED",
            label: "指定"
          }
        ],
        //当前选中的单位
        nowUnit: {},

        //绑定用户
        tempUser: {},
        radioUser: "",
        dialogUser: false,
        userList: [],
        nowKanbanId: ""

      };
    },

    mounted () {
      this.getList()
    },
    computed: {
      dataList () {
        return [this.$store.unitStore.state.nowUnit]
      },
    },
    watch: {

    },

    methods: {
      //树形结构
      nodeClick (val) {
        this.nowUnit=val
      },
      //切换状态
      status_fn (val) {
        this.statusType=val
        this.getList()
      },
      //获取数据
      getList () {
        var d={
          'biName': this.biName,
          'biType': this.biType,
        }
        if(d.biName=="") {
          delete d.biName
        }
        if(d.biType=="") {
          delete d.biType
        }
        getBIList(d).then(res => {
          var list=res.data
          list.forEach(item => {
            item.status=item.status=='ENABLE'? true:false
          })
          this.tableData=list
          this.tabloading=false
          console.log(list);

        })
      },
      //编辑
      edit_fn (row) {
        console.log(row);
        this.nowUnit={
          'id': row.unitId,
          'name': row.unitName,
          'next': [],
        }
        if(row.biType=='CUSTOMIZED') {
          this.radio='指定'
        } else {
          this.radio='通用'
        }
        this.$store.deviceStore.commit('saveKanBanEdit',row.staticResource);
        this.newAdd_fn(row.id)
      },

      //单个删除
      del_fn (row) {
        // if(row.status){
        //   this.$message({ showClose: true, message: `此${row.biName}看板已启用，不可删除`, type: 'warning' });
        //   return
        // }
        this.$confirm(`是否删除 ${row.biName}`,'提示',{
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          deleteBI({"id": row.id}).then(res => {
            if(res.code==200) {
              this.getList();
              this.$message({showClose: true,message: '删除成功',type: 'success'});
            } else {
              res.message? this.$message.error(res.message):this.$message.error('删除失败');

            }
          })
        }).catch(() => {
          // ...
        });
      },

      // 添加弹窗
      add_ed (v,l) {
        this.temp.cardNum=''
        this.temp.remarks=''
        this.dialogStatus='add';
        this.dialogVisible=true;
        this.topLevel=v
        this.$nextTick(() => {
          this.$refs["temp"].clearValidate();
        });
        // this.temp = { EnergyTypeParentId: v || null};
      },
      // 确认添加
      add_fn (formName) {
        this.$refs[formName].validate(valid => {
          if(valid) {
            this.$store.deviceStore.commit('saveKanBanEdit',[]);
            this.newAdd_fn("")
          } else {
            return false;
          }
        });
      },
      //添加函数
      newAdd_fn (neweditID) {
        var d={
          kanBanType: this.radio,
          'editUnitId': neweditID
        }
        this.loading=true
        //获取变量类型
        statementAppTypeGroup().then(res => {
          if(res.code==200) {
            this.$store.deviceStore.commit('saveAppTypeGroup',res.data);
          }
        })
        if(this.radio=='指定') {
          d.unitId=this.nowUnit.id,
            d.unitName=this.nowUnit.name
          if(this.nowUnit.next.length!=0) {
            this.$message({showClose: true,message: '请选择单位',type: 'warning'});
            this.loading=false
            return
          }
          statementVariableTree({"unitId": this.nowUnit.id}).then(res => {
            if(res.code==200) {
              this.handleData(res)
              setTimeout(() => {
                this.$router.push({name: 'customKanBan',params: d})
              },200)
            }
          })

        } else {
          findAppTypeTree().then(res => {
            if(res.code==200) {
              var list=res.data
              list.forEach(item => {
                item.appTypes.forEach((t) => {
                  t.appTypeGroup={
                    "createTime": t.createTime,
                    "energyType": t.energyType,
                    "entityName": t.entityName,
                    "groupId": t.groupId,
                    "id": t.id,
                    "name": t.name,
                    "no": t.no,
                    "useDifference": t.useDifference
                  }
                })
              })
              list=JSON.parse(JSON.stringify(list).replace(/appTypes/g,'ChildDatas').replace(/appTypeGroup/g,'Content').replace(/name/g,'Name').replace(/entityName/g,'Category').replace(/no/g,'appType').replace(/id/g,'keyId'))

              // this.typeGroupData = list
              this.$store.deviceStore.commit('saveDeviceList',list);
              setTimeout(() => {
                // this.loading = false
                this.$router.push({name: 'customKanBan',params: d})
              },200)
            }
          })
        }
      },

      //启用
      switch_fn (val,row) {
        var dateStatus=val? 'ENABLE':'DISABLE'
        var tip=val? '启用':'禁用'
        BiStatus({'dateStatus': dateStatus,'id': row.id}).then(res => {
          console.log(res);
          if(res.code==200) {
            if(val) {
              this.$message({showClose: true,message: `${row.biName} 启用成功`,type: 'success'});
            } else {
              this.$message({showClose: true,message: `${row.biName} 禁用成功`,type: 'warning'});
            }
          } else {
            this.$message.error(`${row.biName} ${tip}失败`);
          }
        })
      },

      //处理企业数据
      handleData (data) {
        data=JSON.parse(JSON.stringify(data).replace(/appTypes/g,'ChildDatas').replace(/groupName/g,"Name").replace(/groupIdAndName/g,"Content").replace(/groupId/g,"Id").replace(/appTypeInfo/g,"Content").replace(/appName/g,"Name"))
        var recursiveFunction=function() {
          const getStr=function(list) {
            list.forEach(function(row) {
              if(row.ChildDatas.length!=0) {
                getStr(row.ChildDatas)
              } else {
                row.ChildDatas=row.Content.groups
              }
            })
          }
          getStr([data.data])
        }
        recursiveFunction()
        // var abc = 	[a.data].filter(item => item.Content.groups.hasOwnProperty('groupIdAndName'))

        var chuData=[data.data]
        var num=0
        var recursiveFunction=function() {
          const getStr=function(list) {
            list.forEach(function(row) {
              if(row.ChildDatas&&row.ChildDatas.length!=0) {
                row['keyId']=num++
                getStr(row.ChildDatas)
              } else {
                row['keyId']=num++
              }
            })
          }
          getStr(chuData)
        }
        recursiveFunction()
        var list=data.data
        list.kanBanType=this.radio
        this.$store.deviceStore.commit('saveDeviceList',[list]);

      },

      //绑定用户弹窗
      binding_fn (row) {
        this.dialogUser=true;
        this.nowKanbanId=row.id
        this.findUserByUnitId(row.unitId)
      },
      //用户列表
      findUserByUnitId (id) {
        this.$api.userApi.findUserByUnitId(id,respon => {
          this.userList=respon
        })
      },

      //确定绑定用户
      addUser_fn () {
        var d={
          'id': this.nowKanbanId,
          'userId': this.radioUser
        }
        bindingUser(d).then(res => {
          console.log("绑定的结果",res);
          if(res.code==200) {
            this.dialogUser=false
          } else {
            res.message? this.$message.error(res.message):this.$message.error('绑定失败');
          }
        })
      },




      //分页功能
      newgetNowPageDataList () {
        this.getList()

      },
      handleSizeChange (val) {
        this.currentSize=val;
        this.newgetNowPageDataList();
      },
      handleCurrentChange (val) {
        this.currentPage=val;
        this.newgetNowPageDataList();
      }


    },
    filters: {
      // 转换时间戳
      "date_format": function(value) { //value就是插值的数据
        if(!value) {
          return ""
        }
        let date=new Date(value);
        let Y=date.getFullYear()+'-';
        let M=(date.getMonth()+1<10? '0'+(date.getMonth()+1):date.getMonth()+1)+'-';
        let D=(date.getDate()<10? '0'+(date.getDate()):date.getDate())+' ';

        let h=(date.getHours()<10? '0'+(date.getHours()):date.getHours())+':';
        let m=(date.getMinutes()<10? '0'+(date.getMinutes()):date.getMinutes())+':';
        let s=(date.getSeconds()<10? '0'+(date.getSeconds()):date.getSeconds());
        let strDate=Y+M+D+h+m+s;
        return strDate
      },
    }
  };
</script>

<style lang="scss" scoped>
  .iCcard {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    .content {
      width: 100%;
      height: 100%;
      background-color: #fff;
      padding: 12px 20px;
      box-sizing: border-box;
      position: relative;

      .iCcard-top {
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 2px solid #E6E6E6;
        padding-bottom: 12px;

        .ic-left {
          span {
            font-size: 16px;
            color: #1a1a1a;
          }
        }

        /deep/.el-upload--picture-card {
          width: 100%;
          height: 32px;
          line-height: 32px;
          border: 0px;
        }

        .btns {
          display: flex;
          align-items: center;
        }

      }

      .iCcard-table {
        margin-top: 20px;

        /deep/.el-table th.is-leaf {
          border-bottom: 0px;
        }

        .status {
          width: 8px;
          height: 8px;
          display: inline-block;
          border-radius: 50%;
          position: relative;
          top: -1px;
        }

        .blue {
          background-color: #52A1FF;

        }

        .ash {
          background-color: #999999;

        }

        .buttoned_box {
          display: flex;
          justify-content: center;
          align-items: center;

          .line {
            display: inline-block;
            width: 1px;
            height: 20px;
            background-color: #E6E6E6;
            margin: 0px 20px;
          }

          .buttoned {
            cursor: pointer;
          }

          /deep/.el-button span {
            font-size: 15px;
            font-weight: 400;
          }
        }
      }

      .paging {
        display: flex;
        justify-content: flex-end;
        margin-top: 15px;
      }

    }

    /deep/.el-dialog__header {
      display: flex;
      align-items: center;
      border-bottom: 1px solid #E6E6E6;

      span {
        color: #67A3ED;
        font-size: 14px;
        font-weight: bold;
      }

      .el-icon-close {
        font-size: 20px !important;
      }

    }

    /deep/.el-dialog__footer {
      margin-top: 20px;
      text-align: right !important;
      border-top: 1px solid #E6E6E6;

      button {
        padding: 8px 17px;
      }
    }

    .demo-temp {
      display: flex;
      flex-wrap: wrap;
    }

    /deep/.el-form-item {
      display: flex;
      margin-left: 20px;
    }

    /deep/.el-form-item__label {
      white-space: nowrap;
      width: 54px;
    }

    /deep/.el-dialog__body {
      padding: 20px 0px 0px 20px !important;
    }


  }
</style>